// extracted by mini-css-extract-plugin
export default {"registerForm":"Register_registerForm__3lSCr","registerIntro":"Register_registerIntro__fu9KG"};